<!-- <template>
  <nav>
    <el-button color="#626aef" :dark="true" plain>Plain</el-button>

    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav>
  <router-view />
</template> -->

<template>
  <router-view />
</template>

<style lang="scss"></style>
